import { t } from "@/i18n-js/instance";

import { ErrorDetails } from "./ErrorDetails";

type SupportType = "email" | "chat";
type IconColor = "red" | "grey";

interface ContactSupportProps {
  errorMessage?: string;
  iconColor?: IconColor;
  supportType?: SupportType;
  title: string;
}

export const ContactSupport = ({
  title,
  errorMessage,
  iconColor = "red",
  supportType = "email",
}: ContactSupportProps) => {
  const handleEmailSupport = () => {
    window.open("mailto:support@circle.so", "emailWindow");
  };

  const handleSupport = () => {
    // TODO: Growth to replace the removed Help Widget chat action.
    if (supportType === "email") {
      handleEmailSupport();
    }
  };

  return (
    <ErrorDetails
      title={title}
      errorMessage={errorMessage}
      buttonLabel={t("pricing_plans.upgrade_modal.actions.contact_support")}
      onClick={handleSupport}
      iconColor={iconColor}
    />
  );
};
